<template>
  <v-form ref="cronogramaForm" :value="cronogramaFormValue">
    <v-row>
      <v-col>  
            <h1 v-if="isComplementar" >{{ formData.id ? "Editar cronograma complementar" : "Novo cronograma complementar"}}</h1>
            <h1 v-else>{{ formData.id ? "Editar cronograma" : "Novo cronograma" }}</h1>
        <p v-if="isComplementar">Lotes adicionados a este cronograma, não serão enviados para a operadora.</p>
        <p v-else>{{ formData.id ? "Edite valor, prazo e previsão de vencimento do cronograma" : "Crie seus cronogramas de acordo com sua agenda de faturamento" }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <label>Prestador</label>
        <v-select
          :disabled="disableFieldsFinal && !isNew"
          v-model="formData.prestador_id"
          :items="prestadores"
          item-value="id"
          placeholder="Selecione"
          item-text="prest_nome"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          outlined
          :rules="formRules.required"
          @change="changePrestador()"
        ></v-select>
      </v-col>
      <v-col cols="8" md="6" sm="12">
        <label>Operadora</label>
        <v-select
          v-model="formData.operadora_ans_id"
          :items="listOperadora"
          item-value="id"
          item-text="oper_nome"
          :rules="formRules.required"
          placeholder="Selecione"
          outlined
          dense
          :readonly="operadoraControl"
          :disabled="
            operadoraControl ||
            !formData.prestador_id ||
            (disableFieldsFinal && !isNew)
          "
          @change="changeOperadora"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" md="6" sm="12" v-if="obrigatorio && obrigatorio.FAT_CRONO_REGRA_TPGUIA && !isComplementar">
        <label>Tipo guia</label>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          v-model="formData.tipo_guia"
          dense
          :items="tipoguiasList"
          placeholder="Selecione"
          outlined
          item-text="descricao"
          item-value="id"
          :rules="obrigatorio && obrigatorio.FAT_CRONO_REGRA_TPGUIA && !isComplementar ? formRules.required : []"
          :disabled="disableFieldsFinal && !isNew"
        ></v-select>
      </v-col>
      <v-col
        cols="8"
        md="6"
        sm="12"
        v-if="obrigatorio && obrigatorio.FAT_CRONO_REGRA_IDENTPREST && !isComplementar"
      >
        <label>Identificação do Prestador</label>
        <v-text-field
          v-model="formData.login_prestador"
          dense
          outlined
          :rules="
           obrigatorio &&  obrigatorio.FAT_CRONO_REGRA_IDENTPREST && !isComplementar ? formRules.required : []
          "
          :disabled="disableFieldsFinal && !isNew"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" md="6" sm="12">
        <label>Responsável</label>
        <v-select
          v-model="formData.owner_id"
          :items="listResponsavel"
          item-value="Id"
          item-text="UserName"
          :rules="formRules.requiredSelect"
          placeholder="Selecione"
          :disabled="disableResponsavel || (disableFieldsFinal && !isNew)"
          outlined
          dense
        ></v-select>
          <!-- :disabled="disableResponsavel || !formData.prestador_id" -->
      </v-col>
      <v-col cols="8" md="6" sm="12" v-if="showField">
        <label>Valor previsão (R$)</label>
         <!-- <b v-show="formData.id==null">*</b> -->
        <v-text-field
          v-model="vl_prev_faturamento"
          v-money="money"
          outlined
          dense
          :rules="formRules.requiredPrice"
          @blur="parsePrice(vl_prev_faturamento)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" md="6" sm="12">
        <label>Prazo de faturamento do cronograma</label>

        <!-- <b v-show="formData.id==null">*</b> -->
        <v-menu
          ref="dataFaturamentoCronos"
          v-model="dataFaturamentoCronos"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              ref="dataFaturamentoCronosValid"
              v-model="dataFaturamento"
              placeholder="Data do faturamento"
              format="DD/MM/YYYY"
              v-mask="'##/##/####'"
              dense
              outlined
              append-icon="mdi-calendar"
              v-bind="attrs"
              :rules="[formRules.requiredField, formRules.typeDateFormated]"
              v-on="on"
              @blur="dt_faturamento = parseDate(dataFaturamento)"
              class="datepicker"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" 
            v-model="dt_faturamento"
            :allowed-dates="allowedDates"
            no-title
            @input="dataFaturamentoCronos = false"
            :min="obrigatorio && obrigatorio.FAT_ENVIO_OPERADORA && !isComplementar? hoje : null"
            :max="isComplementar ?hoje :null"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="8" md="6" sm="12" v-if="showField">
        <label>Previsão de vencimento</label>
        <!-- <b v-show="formData.id==null">*</b> -->
        <v-menu
          ref="dataVencimentoCronos"
          v-model="dataVencimentoCronos"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dataVencimento"
              placeholder="Data de vencimento"
              format="DD/MM/YYYY"
              v-mask="'##/##/####'"
              dense
              outlined
              append-icon="mdi-calendar"
              v-bind="attrs"
              :rules="[formRules.requiredField, formRules.typeDateFormated]"
              v-on="on"
              @blur="dt_prev_vencimento = parseDate(dataVencimento)"
              class="datepicker"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" 
            v-model="dt_prev_vencimento"
            :allowed-dates="allowedDates"
            no-title
            @input="dataVencimentoCronos = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row v-show="!isComplementar">
      <v-col v-if="!isAssociar" cols="8" md="6" sm="12">
        <label v-if="isGestor && !formData.id">Recorrência</label>
        <v-select
          v-model="formData.recorrencia"
          :items="recorrencia"
          item-text="label"
          item-value="value"
          outlined
          dense
          @change="changeRecorrencia()"
          v-if="isGestor && !formData.id"
        ></v-select>
      </v-col>
      <v-col cols="8" md="6" sm="12">
        <label>Notificação</label>
        <v-select
          v-model="formData.qtd_dias_notificacao"
          :items="notificacao"
          item-text="label"
          item-value="value"
          outlined
          dense
          :disabled="!isNew && dadoscronograma && dadoscronograma.status == 'F'"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" md="2" sm="12" v-if="!ocorrenciaControl">
        <label>Ocorrências</label>
        <v-text-field
          v-model="formData.ocorrencia"
          dense
          type="number"
          outlined
          :rules="formRules.required"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <!-- <v-col v-show="formData.id==null" class="py-0" cols="12">
        <p style="font-size:12px" class="mb-0"><b>* Os dados de valor e datas poderão ser alterados posteriormente</b></p>
      </v-col> -->
      <v-col cols="12" class="d-flex align-center justify-end">
        <v-btn outlined small height="30px" color="primary" @click="close()">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed small height="30px" color="primary" @click="validate()">Salvar</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { VMoney } from "v-money";
import moment from "moment";
const  formDataInit = {
        grupo_economico: null,
        dt_faturamento: null,
        dt_prev_vencimento: null,
        id: null,
        prestador_id: null,
        owner_id: null,
        operadora_ans_id: null,
        vl_prev_faturamento: null,
        qtd_dias_notificacao: null,
        recorrencia: null,
        ocorrencia: null,
        login_prestador: "",
        tipo_guia: null,
        sem_bloqueados: true
      }
export default {
  directives: { money: VMoney },
  props: {
    close: Function,
    dadoscronograma: Object,
    disableFields: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
    isComplementar: { type: Boolean, default: false },
    isAssociar: { type: Boolean, default: false }
  },
  data() {
    return {
      disableFieldsFinal: false,
      isGestor: false,
      disableResponsavel: false,
      vl_prev_faturamento: "0,00",
      fat_dias_prev_vencto: 30,
      prestadores: [],
      operadoraControl: true,
      ocorrenciaControl: true,
      hoje: moment().format("YYYY-MM-DD"),
      recorrenciaLimit: 0,
      formData: {
        grupo_economico: null,
        dt_faturamento: null,
        dt_prev_vencimento: null,
        id: null,
        prestador_id: null,
        owner_id: null,
        operadora_ans_id: null,
        vl_prev_faturamento: null,
        qtd_dias_notificacao: null,
        recorrencia: null,
        ocorrencia: null,
        login_prestador: "",
        tipo_guia: null,
        sem_bloqueados: true,
        complementar: false
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      showField: true, //Atualiza a renderização após a mudança de valor
      obrigatorio: {},
      cronogramaFormValue: true,
      dataFaturamento: null,
      dt_faturamento: null,
      dataFaturamentoCronos: false,
      dataVencimento: null,
      dt_prev_vencimento: null,
      dataVencimentoCronos: false,
      dt_expiracao_bool: false,
      clientes: [],
      tipoguiasList: [],
      notificacao: [
        {
          label: "2 dias antes do faturamento",
          value: 2,
        },
        {
          label: "5 dias antes do faturamento",
          value: 5,
        },
        {
          label: "10 dias antes do faturamento",
          value: 10,
        },
        {
          label: "Não receber notificação",
          value: null,
        },
      ],
      recorrencia: [
        {
          label: "Semanal",
          value: "semanal",
        },
        // {
        //   label: "Quinzenal",
        //   value: "quinzenal",
        // },
        {
          label: "Mensal",
          value: "mensal",
        },
        {
          label: "Não se repete",
          value: null,
        },
      ],
    };
  },
  beforeMount() {
    this.prestadores = this.$store.getters[
      "permissions/getPrestadoresByGeco"
    ]();
  },
  mounted() {
    this.formData = {...formDataInit}
    Array.from(document.getElementsByTagName("input")).forEach((el) =>
      el.setAttribute("autocomplete", "off")
    );
    this.isGestor = this.userData.Permissao.faturamento.includes("gestor");
    if (this.prestadores.length == 1) {
      this.formData.prestador_id = this.prestadores[0].id;
      this.changePrestador();
    }
    this.$nextTick(() => {
      if (this.dadoscronograma) {
        // $route.params.id
        this.showField = false;
        this.vl_prev_faturamento = (
          this.dadoscronograma.vl_prev_faturamento / 1
        )
          .toFixed(2)
          .toString()
          .replace(".", ",");
        this.vl_prev_faturamento = this.vl_prev_faturamento.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          "."
        );
        this.formData = {...this.dadoscronograma};
        this.dt_faturamento = this.dadoscronograma.dt_faturamento
          ? this.dadoscronograma.dt_faturamento.split("T")[0]
          : null;
        this.formData.prestador_id = this.dadoscronograma.prestador_id
          ? Number(this.dadoscronograma.prestador_id)
          : null;
        this.formData.operadora_ans_id = this.dadoscronograma.operadora_ans_id
          ? Number(this.dadoscronograma.operadora_ans_id)
          : null;
        this.login_prestador = this.dadoscronograma.login_prestador
          ? this.dadoscronograma.login_prestador
          : "";
        this.tipo_guia = this.dadoscronograma.tipo_guia
          ? this.dadoscronograma.tipo_guia
          : null;
        this.getParametrização();
        this.formData.complementar =  this.dadoscronograma.complementar?  this.dadoscronograma.complementar : this.isComplementar
        setTimeout(
          () =>{
            this.dt_prev_vencimento =  this.dadoscronograma.dt_prev_vencimento? this.dadoscronograma.dt_prev_vencimento.split("T")[0] : null
            this.disableFieldsFinal = !!this.disableFields
          },
          100
        );
        this.showField = true;
      } else {
        this.formData.complementar = this.isComplementar
        this.showField = true;
      }
    });
    this.$refs.cronogramaForm.resetValidation()
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      feriadosList: (state) => state.common.feriadosList,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsavel: (state) => state.faturamento.listResponsavel,
      userData: (state) => state.userData.userData,
    }),
    ...mapGetters({
      getPermissoesModulo: "permissions/getPermissoesModulo",
    }),
  },
  watch: {
    dataFaturamento() {
      this.formData.dt_faturamento = this.parseDate(this.dataFaturamento);
    },
    dt_faturamento(val) {
      setTimeout(() => {
        if (this.$refs.dataFaturamentoCronosValid.validate())
          this.calculateVctoData(val);
        else 
          this.dt_prev_vencimento = null
      }, 10)
      this.dataFaturamento = this.formatDate(val);
      this.formData.dt_faturamento = val;
    },
    dataVencimento() {
      this.formData.dt_prev_vencimento = this.parseDate(this.dataVencimento);
    },
    dt_prev_vencimento() {
      this.dataVencimento = this.formatDate(this.dt_prev_vencimento);
      this.formData.dt_prev_vencimento = this.dt_prev_vencimento;
    },
    fat_dias_prev_vencto(val) {
      if (val) {
        this.calculateVctoData(this.dt_faturamento);
      }
    },
    dadoscronograma: {
      deep: true,
      handler(val) {
        if (val.id != null) {
          this.showField = false;
          this.vl_prev_faturamento = (val.vl_prev_faturamento / 1)
            .toFixed(2)
            .toString()
            .replace(".", ",");
          this.vl_prev_faturamento = this.vl_prev_faturamento? this.vl_prev_faturamento.replace( /\B(?=(\d{3})+(?!\d))/g, ".") : '0,00'
          this.formData = {...val};
          this.dt_faturamento = val.dt_faturamento
            ? val.dt_faturamento.split("T")[0]
            : null;
          this.formData.prestador_id = val.prestador_id
            ? Number(val.prestador_id)
            : null;
          this.formData.operadora_ans_id = val.operadora_ans_id
            ? Number(val.operadora_ans_id)
            : null;
          this.formData.owner_id = val.owner_id
          this.login_prestador = val.login_prestador ? val.login_prestador : "";
          this.tipo_guia = val.tipo_guia ? val.tipo_guia : null;
          this.getParametrização();
          this.formData.complementar = val.complementar? val.complementar : this.isComplementar
          setTimeout(() => {
            // this.dt_prev_vencimento = val.dt_prev_vencimento
            //   ? val.dt_prev_vencimento.split("T")[0]
            //   : null;
            this.showField = true;
          }, 30);
        } else if (this.dadoscronograma) {
          this.formData = {...this.dadoscronograma};
        } else {
          this.formData = {...formDataInit}
        }
        this.formData.grupo_economico = this.grupoEconomico
      },
    },
  },

  methods: {
    ...mapActions({
      getResponsaveis: "faturamento/getResponsaveis",
      getDetalhesCronograma: "faturamento/getDetalhesCronograma",
      getOperadoras: "permissions/getOperadoras",
      getFeriados: "common/getFeriados",
    }),
    allowedDates(val) {
      if(this.feriadosList.length){
        return (
          ![5, 6].includes(new Date(val).getDay()) &&
          !this.feriadosList.find((date) => date.dt_feriado.split("T")[0] == val)
        )
      }
      return (![5, 6].includes(new Date(val).getDay()))
    },
    changeOperadora(val) {
      let ind = this.listOperadora.findIndex((oper) => oper.id == val);
      let valor = this.listOperadora[ind].fat_dias_prev_vencto;
      this.fat_dias_prev_vencto = ind > -1 && valor ? valor : 30;
      this.getParametrização();
    },
    calculateVctoData(val) {
      let vct = moment(val)
        .add(this.fat_dias_prev_vencto, "days")
        .format("YYYY-MM-DD");
      while (!this.allowedDates(vct)) {
        vct = moment(vct).add(1, "days").format("YYYY-MM-DD");
      }
      this.dt_prev_vencimento = vct;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    parsePrice(val) {
      this.formData.vl_prev_faturamento = parseFloat(
        val.replaceAll(".", "").replaceAll(",", ".")
      );
    },
    saveItem(formData) {
      
      formData.grupo_economico = this.grupoEconomico;

      let acao = formData.id ? "updatecronograma" : "addcronograma";
      let payload = formData;

      var data = {
        query: [
          {
            Modulo: "faturamento",
            Acao: acao,
            Payload: payload,
          },
        ],
      };
      
      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.$router.go(-1);
          },
          btConfirm: { name: "Ok", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },

    validate() {
      
      if (!this.$refs.cronogramaForm.validate()) {
        return;
      }
      this.formData.owner_username = this.listResponsavel.find(el=> el.Id==this.formData.owner_id).UserName
      this.formData.prest_nome = this.prestadores.find(el=> el.id==this.formData.prestador_id).prest_nome
      this.formData.oper_nome = this.listOperadora.find(el=> el.id==this.formData.operadora_ans_id).oper_nome
      this.close(this.formData);
    },
    changePrestador() {
      let operadora = Number(this.formData.operadora_ans_id);
      let _this = this
      this.getResponsaveis(this.formData).then(()=>{
        if (!_this.isGestor && !this.isComplementar || this.isComplementar) {
          _this.formData.owner_id = _this.userData.Id.toString()
          let possuiResponsavel = _this.listResponsavel.findIndex(resp => resp.Id == _this.formData.owner_id)
          _this.disableResponsavel = this.isComplementar && possuiResponsavel>-1 ? true : false
        } else {
          let id = _this.dadoscronograma && _this.dadoscronograma.id? _this.dadoscronograma.owner_id.toString(): null
          let ownerIsBlocked = _this.listResponsavel.findIndex(resp => resp.Id == id)
          if( ownerIsBlocked < 0){
            _this.formData.owner_id = null
          } else {
            _this.formData.owner_id = _this.dadoscronograma.owner_id
          } 
        }
      });
      this.getOperadoras(
        Object.assign(this.formData, { modulo_operadora: "faturamento" })
      ).then(() => {
        if (operadora) {
          this.formData.operadora_ans_id = operadora
          this.getParametrização()
        }
      });
      this.operadoraControl = this.formData.prestador != "" ? false : true
      let today = new Date()
      let day = today.getDate().toString()
      let month = (today.getMonth()+1).toString()
      let year = today.getFullYear()
      let opts = {
        grupo_economico: this.grupoEconomico,
        prestador_id: this.formData.prestador_id,
        dt_inicio: `${year}-${month}-${day}`,
        dt_fim: `${year+1}-12-31`,
        referenceYear: year,
      };
      this.getFeriados(opts);
    },
    modalVideo(){
      let paramModal = {
          codigo: "752630275",
          title: "Como criar o cronograma",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
    changeRecorrencia() {
      if (this.formData.recorrencia == null) {
        this.ocorrenciaControl = true
        this.formData.ocorrencia = null
      } else {
        this.ocorrenciaControl = false
        switch (this.formData.recorrencia) {
          case "semanal":
            this.recorrenciaLimit = 52
            break;
          case "quinzenal":
            this.recorrenciaLimit = 24
            break;
          case "mensal":
            this.recorrenciaLimit = 12
            break;
        }
      }
    },
    getParametrização() {
      if (this.formData.id) {
        this.obrigatorio = this.formData.config
        if (this.obrigatorio && this.obrigatorio.FAT_CRONO_REGRA_TPGUIA) {
            this.getTipoGuias()
        }
      }  else {
        this.$store.commit("showLoader", { circle: true });
        let { prestador_id, operadora_ans_id } = this.formData;
        let opts = {
          query: [
            {
              Modulo: "Portal",
              Acao: "getparametrizacoes",
              Payload: {
                grupo_economico: this.grupoEconomico,
                prestador_id,
                operadora_ans_id,
              },
            },
          ],
          noLoader: true,
        };
        this.$store.dispatch("request/doRequest", opts).then((resp) => {
          this.obrigatorio = resp.parametros;
          if (resp.parametros && resp.parametros.FAT_CRONO_REGRA_TPGUIA) {
            this.getTipoGuias()
          } else {
            this.$store.commit("hideLoader");
          }
            
        });
      }
    },
    getTipoGuias(){
      let payload = {
              grupo_economico: this.grupoEconomico,
              modulo_guia: "faturamento",
            };
            this.$store
              .dispatch("common/getTipoGuias", payload)
              .then((result) => {
                this.tipoguiasList = result;
              });
          this.$store.commit("hideLoader");
    }
  },
};
</script>
<style>
</style>